import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
/**
 *有毒气体图层
 */
export default class CPVGasLayer extends BaseLayer{

    constructor(options= {}){
        options.layerName=options.layerName||CONSTANTS.LAYER.CPVGAS;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.forEach((obj) =>{
            let item={...obj};
            item.layerName=self.layerName;
            if(item.longitude&&item.latitude&&item.type==2){
                let entity=new Cesium.Entity({
                    position: Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude, CONSTANTS.ALTITUDE),
                    name: item.name,
                    id:item.id,
                    attributes:item,
                    //立广告牌
                    billboard :{
                        image : require("../../img/map/CPVGas.png"),
                        show : true,
                        width : 60,
                        height : 62,
                        pixelOffset:new Cesium.Cartesian2(0, 0)
                    }
                });
                self.dataSource.entities.add(entity);
            }
        });

    }
};
